export default __webpack_public_path__ + "pgnv-assets/14e5b3e58dc3330b6820bf8286c3fbfb.png";